export default __webpack_public_path__ + "static/media/image5.b09d9754.jpg";